import apiClient from './apiClient';

export const rechargeUser = (id, amount) => {
    return apiClient.post(`/carft/deposit`, { amount,id })
}

export const depositUser = (id, amount) => {
    return apiClient.post(`/carft/withdraw`, { amount,id })
}

export const updateInterestRate = (id, amount) => {
    return apiClient.post(`/carft/rate`, { amount,id })
}
export const updateUser = (id, password,pay_password) => {
    return apiClient.post(`/carft/edit`, { password,pay_password,id })
}
